import {
  NEW_NGUOI_DUNG,
  NEW_NGUOI_DUNG_SUCCESS,
  NEW_NGUOI_DUNG_FAIL,
  DELETE_NGUOI_DUNG,
  DELETE_NGUOI_DUNG_SUCCESS,
  DELETE_NGUOI_DUNG_FAIL,
  NEW_USER_SERVER_IS,
  NEW_USER_SERVER_IS_SUCCESS,
  NEW_USER_SERVER_IS_FAIL
} from 'src/constants/ActionTypes';
import { isUndefined } from 'lodash';
//Saga effects
import {
  put,
  takeEvery
} from 'redux-saga/effects';
import {
  NguoiDungsAPI
} from './Api';

const newNguoiDungs = function* newNguoiDungs(data) {
  try {
    const { payload } = data;
    let receivedData = null;
    if (!isUndefined(payload) && payload.item) {
      receivedData = yield NguoiDungsAPI.newNguoiDung(payload.item);
    } else {
      receivedData = yield NguoiDungsAPI.newNguoiDung(data);
    }
    yield put({
      type: NEW_NGUOI_DUNG_SUCCESS,
      data: receivedData.data,
      status: receivedData.status
    });
  } catch (error) {
    yield put({
      type: NEW_NGUOI_DUNG_FAIL,
      error
    });
  }
};

export const watchNewNguoiDungs = function* watchNewNguoiDungs() {
  yield takeEvery(NEW_NGUOI_DUNG, newNguoiDungs);
};

const deleteNguoiDungs = function* deleteNguoiDungs(data) {
  try {
    const { payload } = data;
    // Xoá role trên IS
    const removeUserRoleIS = yield NguoiDungsAPI.deleteNguoiDungFromIS(payload.email);
    if (removeUserRoleIS.data.success) {
      const receivedData = yield NguoiDungsAPI.deleteNguoiDung(payload.id);
      yield put({
        type: DELETE_NGUOI_DUNG_SUCCESS,
        data: receivedData.data
      });
    }
  } catch (error) {
    yield put({
      type: DELETE_NGUOI_DUNG_FAIL,
      error
    });
  }
};

export const watchDeleteNguoiDungs = function* watchDeleteNguoiDungs() {
  yield takeEvery(DELETE_NGUOI_DUNG, deleteNguoiDungs);
};

// thêm mới tài khoản trên IS
const newUserServerISs = function* newUserServerISs(data) {
  try {
    const { payload } = data;
    const receivedData = yield NguoiDungsAPI.newUserServerIS(payload.item);
    let dataNguoiDungR = [];
    if (receivedData.data.success) {
      // data.dataNguoiDung.idUser = receivedData.data.data.id; // không có id trả về
      dataNguoiDungR = yield newNguoiDungs(payload.dataNguoiDung);
      if(dataNguoiDungR){
        yield put({
          type: NEW_USER_SERVER_IS_SUCCESS,
          data: receivedData.data,
          newNguoiDung: dataNguoiDungR.data
        });
      }
    }
  } catch (error) {
    yield put({
      type: NEW_USER_SERVER_IS_FAIL,
      error
    });
  }
};

export const watchnewUserServerIS = function* watchnewUserServerIS() {
  yield takeEvery(NEW_USER_SERVER_IS, newUserServerISs);
};